export default "__VITE_IMAGE_ASSET__b74848d8__";